<template>
    <div class="first">
        <h3>{{ $t('offer.contact_title') }}</h3>
        <p>{{ $t('offer.contact_hint') }}</p>
        <div class="form-floating">
            <input
                v-model="osoba.meno"
                type="text"
                class="form-control"
                id="floatingMeno"
                placeholder="Meno"
                @focusin="$emit('kontaktna_osoba', true)"
                @focusout="$emit('kontaktna_osoba', false)"
            />
            <label for="floatingMeno">Meno</label>
        </div>
        <div class="form-floating">
            <input
                v-model="osoba.email"
                type="text"
                class="form-control"
                id="floatingEmail"
                placeholder="E-mail"
                @focusin="$emit('kontaktna_osoba', true)"
                @focusout="$emit('kontaktna_osoba', false)"
            />
            <label for="floatingEmail">E-mail</label>
        </div>
        <div class="form-floating">
            <input
                v-model="osoba.cislo"
                type="text"
                class="form-control"
                id="floatingCislo"
                :placeholder="$t('offer.contact_phone_ph')"
                @focusin="$emit('kontaktna_osoba', true)"
                @focusout="$emit('kontaktna_osoba', false)"
            />
            <label for="floatingCislo">{{ $t('offer.contact_phone_label') }}</label>
        </div>
        <load-signature
            v-bind:preloadedfiles="preloadedfiles"
            v-bind:uuidOffer="uuidOffer"
            v-on:data="$emit('data', $event)"
        />
        <div class="form-group mt-4 mobile_doba_inputs">
            <div class="d-flex">
                <input
                    v-model="firemne_udaje_check"
                    @click="
                        firemne_udaje_check = !firemne_udaje_check;
                        osoba.firemne_udaje = '';
                    "
                    type="checkbox"
                    class="toggle testing_contactperson_toggle"
                />
                <label
                    class="block mb-0 mt-1"
                    @click="
                        firemne_udaje_check = !firemne_udaje_check;
                        osoba.firemne_udaje = '';
                    "
                    style="cursor: pointer"
                >
                    {{ $t('offer.contact_add_company') }}
                </label>
                <div class="info">
                    <div class="my_tooltip">
                        {{ $t('offer.contact_data_hint') }}
                        ponuky.
                    </div>
                    <div class="tooltip_hover info_icon">
                        <img src="/img/create_offer/info.svg" alt="" />
                    </div>
                </div>
            </div>
            <div v-show="firemne_udaje_check" class="doba_inputs p-0 mb-2">
                <div class="form-floating">
                    <textarea
                        v-model="osoba.firemne_udaje"
                        class="form-control testing_contactperson_textarea"
                        :placeholder="$t('offer.contact_company_ph')"
                        id="floatingTextarea2"
                        style="height: 150px"
                        @focusin="$emit('firemne_udaje', true)"
                        @focusout="$emit('firemne_udaje', false)"
                    >
                    </textarea>
                    <label for="floatingTextarea2"
                        >{{ $t('offer.contact_company_label') }}</label
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoadSignature from "./LoadSignature.vue";
import { EventBus } from "./EventBus";
export default {
    components: { LoadSignature },
    props: ["personinfo", "uuidOffer", "preloadedfiles", "moja_firma"],
    data() {
        return {
            firemne_udaje_check: false,
            osoba: {
                meno: null,
                email: null,
                cislo: null,
                firemne_udaje: "",
            },
        };
    },
    mounted() {
        // Klik na firmu v selecte (aj na uz vybratu) vzdy prepise firemne udaje
        EventBus.$on("mojafirma_selected", this.fillFromMojaFirma);
    },
    beforeDestroy() {
        EventBus.$off("mojafirma_selected", this.fillFromMojaFirma);
    },
    methods: {
        fillFromMojaFirma(firma) {
            if (!firma) return;
            this.firemne_udaje_check = false;
            this.osoba.firemne_udaje = "";
            const properties = [
                "nazov_spolocnosti",
                "ico",
                "dic",
                "ic_dph",
                "ulica",
                "psc",
                "mesto",
            ];
            properties.forEach((prop) => {
                if (firma[prop] != null) {
                    this.firemne_udaje_check = true;
                    if (prop == "ico" && firma[prop] != "") {
                        this.osoba.firemne_udaje += this.$t('offer.ico');
                        this.osoba.firemne_udaje += firma[prop] + "\n";
                    } else if (prop == "dic" && firma[prop] != "") {
                        this.osoba.firemne_udaje += this.$t('offer.dic');
                        this.osoba.firemne_udaje += firma[prop] + "\n";
                    } else if (prop == "ic_dph" && firma[prop] != "") {
                        this.osoba.firemne_udaje += this.$t('offer.icdph');
                        this.osoba.firemne_udaje += firma[prop] + "\n";
                    } else if (firma[prop] != "") {
                        this.osoba.firemne_udaje += firma[prop] + "\n";
                    }
                }
            });
            this.osoba.meno = firma["osoba"];
            this.osoba.email = firma["osoba_email"];
            this.osoba.cislo = firma["osoba_tel"];
        },
    },
    watch: {
        moja_firma: {
            handler() {
                this.fillFromMojaFirma(this.moja_firma);
            },
            deep: true,
        },

        personinfo: {
            handler() {
                this.osoba.meno = this.personinfo.osoba;
                this.osoba.email = this.personinfo.email;
                this.osoba.cislo = this.personinfo.cislo;
                if (
                    this.personinfo.firemne_udaje != "" &&
                    this.personinfo.firemne_udaje != null
                ) {
                    this.osoba.firemne_udaje = this.personinfo.firemne_udaje;
                    this.firemne_udaje_check = true;
                }
            },
            deep: true,
        },
        osoba: {
            handler() {
                this.$emit("osobaInfo", this.osoba);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.form-floating {
    margin-top: 20px;
}
h3 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #212541;
}
p {
    margin-top: 7px;

    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #9598a7;
}
.form-floating > label {
    padding: 22px 13px;

    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #9598a7;
}
input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #212541;

    border: 1px solid #dde3e8;
    border-radius: 0;
}
label {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #212541;
}
input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    margin: 0px 10px 0 0px;
    background: #c7d4eb;
    border-radius: 25px;
}
.toggle label {
    @media (max-width: 600px) {
        width: 70%;
    }
}
.toggle {
    height: 22px;
    width: 40px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: none;
    background: #ffffff;
    border-radius: 3px;
    transition: all 0.2s ease;
    &:focus {
        outline: 0;
    }
    &:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }
    &:checked {
        border-color: #2ed8b6;
        background: #2ed8b6;
    }
    &:checked:after {
        transform: translatex(20px);
    }
}
.mobile_doba_inputs {
    display: grid !important;
    label {
        @media (max-width: 600px) {
            width: 70%;
        }
    }
}
.doba_inputs {
    background: white;
    padding: 20px;
    width: 100%;
    @media (max-width: 550px) {
        margin: 20px 0 !important;
    }
    .form-floating > label,
    .float-container label {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598a7;
    }
    input {
        height: 50px;
        border-radius: 0;
    }
    textarea {
        border-radius: 0;
    }
}
.info {
    position: relative;
    height: 20px;
    margin-left: 10px;
    .info_icon {
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;
        img {
            width: 80%;
            height: 80%;
        }
    }
    .my_tooltip {
        bottom: 22px;
        right: -7px;
    }
}
.agree_tooltip {
    position: relative;
}
.my_tooltip {
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #f3385a;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity 0.5s ease-in-out;
    &::after {
        content: "";
        width: 15px;
        height: 15px;
        background: #f3385a;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}
</style>
